import React from 'react';
import PropTypes from 'prop-types';

import { getCategoryItems } from '../utils';

const SpecialCategory = ({ children, specials }) => {
  return getCategoryItems(specials).map(({ name, items }) => (
    <React.Fragment key={name}>
      <h3 className="special-category">{name}</h3>
      {children(items)}
    </React.Fragment>
  ));
};

SpecialCategory.propTypes = {
  specials: PropTypes.shape({
    categories: PropTypes.array,
    items: PropTypes.array,
  }).isRequired,
};

export default SpecialCategory;
